module.exports = kolibriGlobal.coreVue.mixins.themeMixin;